const allConfigs = {
  local: {
    env: 'stage',
    heroImageUrl: 'https://athlinks-stage-heroes.s3.amazonaws.com/',
    customHeroImageUrl: 'https://s3.amazonaws.com/bazu-static-stage/',
    ATHLINKS_API_HOST: 'https://local.athlinks.com:3443/athlinks', //https://beta.athlinks.com/athlinks for Master Landing page
    WEATHER_API_HOST: 'https://local.athlinks.com:3443/forecast',
    athlinksUrl: 'https://alaska-stage.athlinks.com',
    bragiUrl: 'https://local.athlinks.com:3443', //https://beta.athlinks.com/ if you want to check real ELP hero image
    chronotrackUrl: 'https://admin-qa.chronotrack.com',
    chronotrackApiUrl: 'https://local.athlinks.com:3443/ctl-api',
    chronotrackRegisterUrl: 'https://register-qa.chronotrack.com',
    erosUrl: 'https://local.athlinks.com:3443/eros',
    keycloakUrl: 'https://accounts-stage.athlinks.com', //for local: 'https://local.athlinks.com:3443/keycloak'
    resultsHubUrl: 'https://local.athlinks.com:3443', //for local results-hub backed resultsHubUrl: 'https://local.athlinks.com:6443',
    cdnUrl: 'https://local.athlinks.com:3443',
    imgixStaticUrl: 'https://athlinks-static-dev.imgix.net/',  //maps to bazu-static-dev bucket
    finisherCertificateUrl: 'https://cert-stage.athlinks.com/finisherCertificate',
    resultsApiUrl: 'https://results-stage.athlinks.com',
    mapTrackingUrl: 'https://map-stage.athlinks.com',
    mapS3BucketName: 'athlinks-stage-maps-event-processed',
    athleteApiUrl: 'https://athlete-ui-api-stage.athlinks.com/graphql'
  },
  local_prod: {
    env: 'dev',
    heroImageUrl: 'https://d4k05pygp2ljo.cloudfront.net/',
    customHeroImageUrl: 'https://s3.amazonaws.com/bazu-static/',
    ATHLINKS_API_HOST: 'https://local.athlinks.com/athlinks',
    WEATHER_API_HOST: 'https://local.athlinks.com/forecast',
    athlinksUrl: 'https://alaska.athlinks.com',
    bragiUrl: 'https://local.athlinks.com',
    chronotrackUrl: 'https://admin.chronotrack.com',
    chronotrackApiUrl: 'https://local.athlinks.com/ctl-api',
    chronotrackRegisterUrl: 'https://register.chronotrack.com',
    erosUrl: 'https://local.athlinks.com/eros',
    keycloakUrl: 'https://accounts.athlinks.com',
    resultsHubUrl: 'https://local.athlinks.com', //for local results-hub backed resultsHubUrl: 'https://local.athlinks.com:6443',
    cdnUrl: 'https://local.athlinks.com',
    imgixStaticUrl: 'https://athlinks-static.imgix.net/',  //maps to bazu-static bucket
    finisherCertificateUrl: 'https://cert.athlinks.com/finisherCertificate',
    resultsApiUrl: 'https://results.athlinks.com',
    mapTrackingUrl: 'https://map.athlinks.com',
    mapS3BucketName: 'athlinks-prod-maps-event-processed',
    athleteApiUrl: 'https://athlete-ui-api.athlinks.com/graphql'

  },
  dev: {
    env: 'dev',
    heroImageUrl: 'https://athlinks-dev-heroes.s3.amazonaws.com/',
    customHeroImageUrl: 'https://s3.amazonaws.com/bazu-static-dev/',
    ATHLINKS_API_HOST: 'https://alaska-dev.athlinks.com',
    WEATHER_API_HOST: 'https://dev.athlinks.com/forecast',
    athlinksUrl: 'https://alaska-dev.athlinks.com',
    bragiUrl: 'https://dev.athlinks.com',
    chronotrackUrl: 'https://admin-qa.chronotrack.com',
    chronotrackApiUrl: 'https://dev.athlinks.com/ctl-api',
    chronotrackRegisterUrl: 'https://register-qa.chronotrack.com',
    erosUrl: 'https://dev.athlinks.com/eros',
    keycloakUrl: 'https://accounts-dev.athlinks.com',
    resultsHubUrl: 'https://results-hub-dev.athlinks.com',
    cdnUrl: 'https://dev.athlinks.com',
    imgixStaticUrl: 'https://athlinks-static-dev.imgix.net/',  //maps to bazu-static-dev bucket
    finisherCertificateUrl: 'https://cert-stage.athlinks.com/finisherCertificate', // TODO: why doesn't dev work
    resultsApiUrl: 'https://results-stage.athlinks.com',
    mapTrackingUrl: 'https://map-stage.athlinks.com',
    mapS3BucketName: 'athlinks-stage-maps-event-processed',
    athleteApiUrl: 'https://athlete-ui-api-stage.athlinks.com/graphql'
  },
  stage: {
    env: 'stage',
    heroImageUrl: 'https://athlinks-stage-heroes.s3.amazonaws.com/',
    customHeroImageUrl: 'https://s3.amazonaws.com/bazu-static-qa/',
    ATHLINKS_API_HOST: 'https://alaska-stage.athlinks.com',
    WEATHER_API_HOST: window.location.origin + '/forecast',
    athlinksUrl: 'https://alaska-stage.athlinks.com',
    bragiUrl: window.location.origin,
    chronotrackUrl: 'https://admin-qa.chronotrack.com',
    chronotrackApiUrl: window.location.origin + '/ctl-api',
    chronotrackRegisterUrl: 'https://register-qa.chronotrack.com',
    erosUrl: window.location.origin + '/eros',
    keycloakUrl: 'https://accounts-stage.athlinks.com',
    resultsHubUrl: 'https://results-hub-stage.athlinks.com',
    cdnUrl: window.location.origin,
    imgixStaticUrl: 'https://athlinks-static-qa.imgix.net/',  //maps to bazu-static-qa bucket
    finisherCertificateUrl: 'https://cert-stage.athlinks.com/finisherCertificate',
    resultsApiUrl: 'https://results-stage.athlinks.com',
    mapTrackingUrl: 'https://map-stage.athlinks.com',
    mapS3BucketName: 'athlinks-stage-maps-event-processed',
    athleteApiUrl: 'https://athlete-ui-api-stage.athlinks.com/graphql'
  },
  prod: {
    env: 'prod',
    heroImageUrl: 'https://d4k05pygp2ljo.cloudfront.net/',
    customHeroImageUrl: 'https://d1wtzsjnbruk95.cloudfront.net/',
    ATHLINKS_API_HOST: 'https://alaska.athlinks.com',
    WEATHER_API_HOST: 'https://www.athlinks.com/forecast',
    athlinksUrl: 'https://alaska.athlinks.com',
    bragiUrl: 'https://www.athlinks.com',
    chronotrackUrl: 'https://admin.chronotrack.com',
    chronotrackApiUrl: 'https://www.athlinks.com/ctl-api',
    chronotrackRegisterUrl: 'https://register.chronotrack.com',
    erosUrl: 'https://www.athlinks.com/eros',
    keycloakUrl: 'https://accounts.athlinks.com',
    resultsHubUrl: 'https://results-hub.athlinks.com',
    cdnUrl: 'https://d33vaoadodpfl.cloudfront.net',
    imgixStaticUrl: 'https://athlinks-static.imgix.net/',  //maps to bazu-static bucket
    createCertificateApiUrl: 'https://apigw.athlinks.com/createFinisherCert',
    certificateBucket: 'bazu-photos',
    customCertBasePath: 'https://s3.amazonaws.com/bazu-static',
    finisherCertificateUrl: 'https://cert.athlinks.com/finisherCertificate',
    resultsApiUrl: 'https://results.athlinks.com',
    mapTrackingUrl: 'https://map.athlinks.com',
    mapS3BucketName: 'athlinks-prod-maps-event-processed',
    athleteApiUrl: 'https://athlete-ui-api.athlinks.com/graphql'
  },
  all: {
    bazuUrl: 'https://d3qqwzntkq5rvs.cloudfront.net/',
    googleApiKey: 'AIzaSyCeb-t1WCXp7PpuCIfCUtusR-41n_xZMRg',
    tokenRefreshInterval: 45000,
    keycloakRealm: 'athlinks',
    keycloakClientId: 'bragi',
    requireActivity: false,
    shortPollingTime: 30000,
    longPollingTime: 60000 * 5,
    cdnUrl: '',
    refreshTokenCookieName: '_rtok',
    accessTokenCookieName: '_atok',
    androidAppId: 'com.athlinksmobile',
    iosAppId: '1153823287',
    searchCharLimit: 74,
    fbAppId: '1773281759556502',
    numResultsPerPage: 50,
    hotjarAuthenticated: 466948,
    hotjarUnauthenticated: 736393,
    recaptchaKey: '6LfZ4nEUAAAAAPddWCAmh_deDwQ81bW-XqMlAhVY',
    // useMockPrinter: true,
  }
};

function getConfigs() {
  if(__DEVELOPMENT__) {
    /*
        __DEV_PROD__ is set by anubis in the webpack.dev.config, its only available in __DEVELOPMEMT__.

        for __DEV_PROD__ mode to work, add the following to your /etc/hosts file:
        127.0.0.1       www.athlinks.com

        www.athlinks.com makes calls to www.athlinks.com, the above hosts entry resolves those calls to 127.0.0.1
        so that your can run your code locally from the prod 'host' environment.
    */
    if(__DEV_PROD__) {
      if (__DEV_PROD__ === 2) {
        const windows = {
          athlinksUrl: 'http://windows.athlinks.com:5970',
          keycloakUrl: 'https://accounts-local.athlinks.com:8443',
          chronotrackUrl: 'https://local.chronotrack.com:4443',
          chronotrackRegisterUrl: 'https://local.chronotrack.com:4443',
        };
        return Object.assign({}, allConfigs.all, allConfigs.local, windows);
      }
      return Object.assign({}, allConfigs.all, allConfigs.local_prod);
    }
    return Object.assign({}, allConfigs.all, allConfigs.local);
  }
  const envServiceTag = (typeof(window) === 'object' && window.config && window.config.serviceTag);

  if(process.env.SERVICE_TAGS === 'athlinks-dev' || envServiceTag === 'athlinks-dev') {
    return Object.assign({}, allConfigs.all, allConfigs.dev);
  }

  if(process.env.SERVICE_TAGS === 'athlinks-stage' || envServiceTag === 'athlinks-stage') {
    return Object.assign({}, allConfigs.all, allConfigs.stage);
  }

  return Object.assign({}, allConfigs.all, allConfigs.prod);
}

export const configs = getConfigs();



/** WEBPACK FOOTER **
 ** ./configs.js
 **/